var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0h4v6h6v4h-6v6H6v-6H0V6h6z","fillRule":"evenodd"}));
}

Plus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Plus;

Plus.default = Plus;
